import { BMEventsType } from '../types';

import type { BasePageLoadMetricData } from './base-page-load-metric';

export const isPageLoadMetricData = (data: any): data is BasePageLoadMetricData => {
	return data.type === BMEventsType.PAGE_LOAD;
};
